// import React from "react";
// // import { Users, BarChart3, Award } from "tabler-icons-react";
// import {
//   Award,
//   Users,
//   Settings,
//   Target,
//   ChartBar,
//   Beaker,
// } from "tabler-icons-react";

// export default function Collaboration() {
//   return (
//     <div>
//       <div className="text-center mb-12">
//         <h3 className="text-2xl font-bold text-gray-900 mb-4">
//           Ongoing Collaborations
//         </h3>
//         <p className="text-lg text-gray-600">
//           Strategic partnerships driving innovation in dairy technology
//         </p>
//       </div>

//       <div className="grid md:grid-cols-2 gap-8">
//         <div className="bg-gradient-to-br from-purple-50 to-purple-100 p-8 rounded-2xl hover:shadow-lg transition-shadow">
//           <div className="bg-purple-500 p-4 rounded-full w-16 h-16 mb-6 flex items-center justify-center">
//             <Users className="w-8 h-8 text-white" />
//           </div>
//           <h4 className="text-xl font-bold text-gray-900 mb-4">
//             Government Partnerships
//           </h4>
//           <p className="text-gray-600 mb-6">
//             Collaborating with government agencies to modernize Nepal's dairy
//             infrastructure, supply essential goods, provide training, and
//             improve milk quality standards nationwide.
//           </p>
//           <ul className="text-sm text-gray-600 space-y-2">
//             <li>
//               • Local Government level Muncipal or Rural Adminstrative Divisions
//             </li>
//             <li>• Bagmati Province Dairy Development Board</li>

//             <li>• Various Training of Dairy Development Board Nepal</li>
//           </ul>
//         </div>

//         <div className="bg-gradient-to-br from-teal-50 to-teal-100 p-8 rounded-2xl hover:shadow-lg transition-shadow">
//           <div className="bg-teal-500 p-4 rounded-full w-16 h-16 mb-6 flex items-center justify-center">
//             {/* <BarChart3 className="w-8 h-8 text-white" /> */}
//             <ChartBar className="w-8 h-8 text-white" />
//           </div>
//           <h4 className="text-xl font-bold text-gray-900 mb-4">
//             Technology Partners
//           </h4>
//           <p className="text-gray-600 mb-6">
//             Working with leading technology companies to integrate AI and IoT
//             solutions into our dairy management systems.
//           </p>
//           <ul className="text-sm text-gray-600 space-y-2">
//             <li>• AI technology integration</li>
//             <li>• Cloud platform partnerships</li>
//             <li>• IoT sensor development</li>
//             <li>• Data analytics collaboration</li>
//           </ul>
//         </div>

//         <div className="bg-gradient-to-br from-indigo-50 to-indigo-100 p-8 rounded-2xl hover:shadow-lg transition-shadow">
//           <div className="bg-indigo-500 p-4 rounded-full w-16 h-16 mb-6 flex items-center justify-center">
//             <Award className="w-8 h-8 text-white" />
//           </div>
//           <h4 className="text-xl font-bold text-gray-900 mb-4">
//             Collaborations
//           </h4>
//           <p className="text-gray-600 mb-6">
//             Expanding our reach through partnerships and knowledge exchange
//             programs with dairy technology leaders.
//           </p>
//           <ul className="text-sm text-gray-600 space-y-2">
//             <li>• European technology transfer</li>
//             <li>• SAARC region partnerships</li>
//             <li>• International quality standards</li>
//             <li>• Global market expansion</li>
//           </ul>
//         </div>

//         <div className="bg-gradient-to-br from-rose-50 to-rose-100 p-8 rounded-2xl hover:shadow-lg transition-shadow">
//           <div className="bg-rose-500 p-4 rounded-full w-16 h-16 mb-6 flex items-center justify-center">
//             <Users className="w-8 h-8 text-white" />
//           </div>
//           <h4 className="text-xl font-bold text-gray-900 mb-4">
//             Academic Partnerships
//           </h4>
//           <p className="text-gray-600 mb-6">
//             Collaborating with universities and research institutions to advance
//             dairy science and technology education.
//           </p>
//           <ul className="text-sm text-gray-600 space-y-2">
//             <li>• University research programs</li>
//             <li>• Student internship programs</li>
//             <li>• Joint research projects</li>
//             <li>• Technology workshops</li>
//           </ul>
//         </div>
//       </div>
//     </div>
//   );
// }

////with logo

import React from "react";

import esp32 from "../image/esp.png";
import microchip from "../image/microchip.png";
import novoton from "../image/novoton.png";
import jlcpcb from "../image/jlcpcb.png";
import hexaUltra from "../image/hexaultra.jpg";

import bnblogo from "../image/bnb.png";
import Ghumtipasal from "../image/ghumtipasal.jpg";
import Highlightmulti from "../image/highlight.png";
import Absolute from "../image/absolute.jpg";
import { Award, Users, ChartBar } from "tabler-icons-react";

export default function Collaboration() {
  return (
    <div>
      <div className="text-center mb-12">
        <h3 className="text-2xl font-bold text-gray-900 mb-4">
          Ongoing Collaborations
        </h3>
        <p className="text-lg text-gray-600">
          Strategic partnerships driving innovation in dairy technology
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-8">
        {/* Government Partnerships */}
        <div className="bg-gradient-to-br from-purple-50 to-purple-100 p-8 rounded-2xl hover:shadow-lg transition-shadow">
          <div className="bg-purple-500 p-4 rounded-full w-16 h-16 mb-6 flex items-center justify-center">
            <Users className="w-8 h-8 text-white" />
          </div>
          <h4 className="text-xl font-bold text-gray-900 mb-4">
            Government Partnerships
          </h4>
          <p className="text-gray-600 mb-6">
            Collaborating with government agencies to modernize Nepal's dairy
            infrastructure, supply essential goods, provide training, and
            improve milk quality standards nationwide.
          </p>
          <ul className="text-sm text-gray-600 space-y-2">
            <li>
              • Local Government level Municipal or Rural Administrative
              Divisions
            </li>
            <li>• Bagmati Province Dairy Development Board</li>
            <li>• Various Training of Dairy Development Board Nepal</li>
          </ul>
        </div>

        {/* Technology Partners */}
        <div className="bg-gradient-to-br from-teal-50 to-teal-100 p-8 rounded-2xl hover:shadow-lg transition-shadow">
          <div className="bg-teal-500 p-4 rounded-full w-16 h-16 mb-6 flex items-center justify-center">
            <ChartBar className="w-8 h-8 text-white" />
          </div>
          <h4 className="text-xl font-bold text-gray-900 mb-4">
            Technology Partners
          </h4>
          <p className="text-gray-600 mb-6">
            Working with leading technology companies to integrate AI and IoT
            solutions into our dairy management systems.
          </p>
          <ul className="text-sm text-gray-600 space-y-2 mb-6">
            <li>• AI technology integration</li>
            <li>• Cloud platform partnerships</li>
            <li>• IoT sensor development</li>
            <li>• Data analytics collaboration</li>
          </ul>

          {/* Logos */}
          {/* <div className="flex flex-wrap gap-4 items-center justify-start">
            <img src={esp32} alt="ESP Logo" className="h-12" />
            <img src={novoton} alt="Novoton Logo" className="h-12" />
            <img src={microchip} alt="Microchip Logo" className="h-12" />
            <img src={jlcpcb} alt="JLCPCB Logo" className="h-12" />
          </div> */}

          <div className="flex flex-wrap gap-4 items-center justify-start">
            <img
              src={esp32}
              alt="ESP Logo"
              className="h-12 w-auto object-contain"
            />
            <img
              src={novoton}
              alt="Novoton Logo"
              className="h-12 w-auto object-contain"
            />
            <img
              src={microchip}
              alt="Microchip Logo"
              className="h-12 w-auto object-contain"
            />
            <img
              src={jlcpcb}
              alt="JLCPCB Logo"
              className="h-12 w-auto object-contain"
            />
          </div>
        </div>

        {/* Collaborations */}
        <div className="bg-gradient-to-br from-indigo-50 to-indigo-100 p-8 rounded-2xl hover:shadow-lg transition-shadow">
          <div className="bg-indigo-500 p-4 rounded-full w-16 h-16 mb-6 flex items-center justify-center">
            <Award className="w-8 h-8 text-white" />
          </div>
          <h4 className="text-xl font-bold text-gray-900 mb-4">
            Collaborations
          </h4>
          <p className="text-gray-600 mb-6">
            Expanding our reach through partnerships and knowledge exchange
            programs with dairy technology leaders.
          </p>
          <ul className="text-sm text-gray-600 space-y-2 mb-6">
            <li>• European technology transfer</li>
            <li>• SAARC region partnerships</li>
            <li>• International quality standards</li>
            <li>• Global market expansion</li>
          </ul>

          {/* Logos */}
          {/* <div className="flex flex-wrap gap-4 items-center justify-start">
            <img src={bnblogo} alt="BNB Logo" className="h-12" />
            <img src={Ghumtipasal} alt="Ghumtipasal Logo" className="h-12" />
            <img
              src={Highlightmulti}
              alt="Highlight Trade Logo"
              className="h-12"
            />
            <img src={Smartenlogo} alt="SmarterN Logo" className="h-12" />
          </div> */}
          <div className="flex flex-wrap gap-4 items-center justify-start">
            <img
              src={bnblogo}
              alt="BNB Logo"
              className="h-12 w-auto object-contain"
            />
            <img
              src={Ghumtipasal}
              alt="Ghumtipasal Logo"
              className="h-12 w-auto object-contain"
            />
            <img
              src={Highlightmulti}
              alt="Highlight Trade Logo"
              className="h-12 w-auto object-contain"
            />
            <img
              src={Absolute}
              alt="Absolute Logo"
              className="h-12 w-auto object-contain"
            />
          </div>
        </div>

        {/* Academic Partnerships */}
        <div className="bg-gradient-to-br from-rose-50 to-rose-100 p-8 rounded-2xl hover:shadow-lg transition-shadow">
          <div className="bg-rose-500 p-4 rounded-full w-16 h-16 mb-6 flex items-center justify-center">
            <Users className="w-8 h-8 text-white" />
          </div>
          <h4 className="text-xl font-bold text-gray-900 mb-4">
            Academic Partnerships
          </h4>
          <p className="text-gray-600 mb-6">
            Collaborating with universities and research institutions to advance
            dairy science and technology education.
          </p>
          <ul className="text-sm text-gray-600 space-y-2">
            <li>• University research programs</li>
            <li>• Student internship programs</li>
            <li>• Joint research projects</li>
            <li>• Technology workshops</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
